import React, { createContext, useContext } from "react";
import useAuth from "../hooks/useAuth";

// ✅ Create an Auth Context
const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {

  //console.log("🔄 AuthProvider: Rendering..."); // Add this line

  const auth = useAuth();

  return (
    <AuthContext.Provider value={auth}>
      {children}
    </AuthContext.Provider>
  );
};

// ✅ Custom hook to access the shared Auth Context
export const useSharedAuth = () => useContext(AuthContext);
